import { BaseService } from '@Services/index'
import { ITicket } from '@Store/types';
import {i18n} from "@I18n/index";

export class SupportService extends BaseService {

	public getNotificationSupport(): Promise<any> {
		return super.get(`/notification/support/`)
	}

	public getChangeLog(): Promise<any> {
		return super.get(`/support/change-log`)
	}

	public getFaqList(): Promise<any> {
		return super.get(`/support/faq/list`)
	}

	public getOpenedTicketList(): Promise<any> {
		return super.get(`/support/opened/list`)
	}

	public getClosedTicketList(): Promise<any> {
		return super.get(`/support/closed/list`)
	}

	public getTicket(sup_id: string): Promise<any> {
		return super.get(`/support/ticket/${sup_id}`)
	}

	public sendComment(sup_id: string, comment:string): Promise<any> {
		return super.put(`/support/ticket/${sup_id}`, {comment: comment})
	}

	public createTicket(ticket:ITicket): Promise<any> {
		return super.post(`/support/ticket/`, ticket)
	}

	public async createJitbitUser(): Promise<any> {
		return super.post('support/create/jitbit-user')
			.then(data => { return Promise.resolve(data) })
			.catch((error: any) => {
				let message = i18n.t('vm.root.help.home-help.no-support-account.failed').toString()

				const existingAccountCodes = [400, 409]

				if (error && existingAccountCodes.includes(error.status)) {
					message = i18n.t('vm.root.help.home-help.no-support-account.already-exists').toString()
				}

				return Promise.reject(message)
			})
	}
}
